/**
 * Кнопки §63.
 *
 * primary — accent-фон, максимум ОДНА очевидная primary action на viewport;
 * secondary — тёмная поверхность + border;
 * tertiary — text / ghost.
 * Радиус ~8px, без pill.
 */
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import clsx from 'clsx';

type Variant = 'primary' | 'secondary' | 'tertiary';
type Size = 'sm' | 'md';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
}

const variants: Record<Variant, string> = {
  primary: 'bg-accent text-page hover:bg-accent-hover active:bg-accent-pressed',
  secondary:
    'bg-surface-secondary text-content border border-line hover:bg-surface-hover hover:border-line-strong',
  tertiary: 'text-content-secondary hover:text-content hover:bg-surface-hover',
};

const sizes: Record<Size, string> = {
  sm: 'h-8 px-3 text-meta',
  md: 'h-10 px-4 text-button',
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { variant = 'secondary', size = 'md', className, ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      className={clsx(
        'inline-flex items-center justify-center gap-2 rounded-control font-medium',
        'transition-colors duration-DEFAULT',
        'disabled:pointer-events-none disabled:opacity-40',
        variants[variant],
        sizes[size],
        className,
      )}
      {...props}
    />
  );
});
